import { Text } from '@chakra-ui/react';

export const GridItemHeaderText = (props) => <Text color="gray2" fontSize="sm" casing="uppercase" {...props} />;
